import { Component, Input } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'app-score-bar',
    templateUrl: './score-bar.component.html',
    styleUrls: ['./score-bar.component.scss'],
    imports: [NgClass, NgStyle],
})
export class ScoreBarComponent {
    @Input() score: number;

    get scoreLength() {
        return (this.score * 100).toFixed(2) + '%';
    }
}
